import styles from './AllMessages.module.css';

export enum StyleElement {
    Container = 'Container',
}

export function classNameForElement(element: StyleElement): string {
    const name = element.toString();
    return styles[name] ?? '';
}
